import { EntityAudit } from "@modernary/mui/components/audit";
import { EntityDocuments } from "@modernary/mui/components/document";
import { EntityNotes } from "@modernary/mui/components/note";
import { RouterView, type RouterOptions } from "vue-router";

// Troubleshoot your routes using this - https://paths.esm.dev

const names = {
  items: "InternalRoutingItem.Items",
  list: "InternalRoutingItem.ItemList",
  new: "InternalRoutingItem.ItemNew",
  base: "InternalRoutingItem.ItemBase",
  view: "InternalRoutingItem.ItemView",
  edit: "InternalRoutingItem.ItemEdit",
  notes: "InternalRoutingItem.ItemNotes",
  noteEdit: "InternalRoutingItem.ItemNoteEdit",
  noteNew: "InternalRoutingItem.ItemNoteNew",
  // documents: "InternalRoutingItem.ItemDocuments",
  // documentsEdit: "InternalRoutingItem.ItemDocumentsEdit",
  // documentsNew: "InternalRoutingItem.ItemDocumentsNew",
  workFlowTasks: "InternalRoutingItem.ItemWorkFlowTasks",
  workFlowTaskEdit: "InternalRoutingItem.ItemWorkFlowTaskEdit",
  workFlowTaskNew: "InternalRoutingItem.ItemWorkFlowTaskNew",
  audit: "InternalRoutingItem.ItemAudit",
};

export { names as internalRoutingItemRouteNames };

const internalRoutingItemRoutes: RouterOptions["routes"] = [
  {
    path: "/internalRoutingItem",
    name: names.items,
    component: {
      render: () => <RouterView />,
    },
    redirect: { name: names.list },
    children: [
      {
        path: "list",
        name: names.list,
        meta: { title: "Internal Routing Items" },
        component: () => import("@/views/internalRoutingItem/InternalRoutingItemList.vue"),
      },
      {
        path: "new",
        component: () => import("@/views/internalRoutingItem/InternalRoutingItemBase.vue"),
        redirect: { name: names.new },
        props: true,
        children: [
          {
            path: "",
            name: names.new,
            meta: { title: "New Internal Routing Item", isNew: true },
            component: () => import("@/views/internalRoutingItem/InternalRoutingItemEdit.vue"),
          },
        ],
      },
      {
        path: ":id(\\d+)",
        name: names.base,
        component: () => import("@/views/internalRoutingItem/InternalRoutingItemBase.vue"),
        redirect: { name: names.view },
        children: [
          {
            path: "view",
            name: names.view,
            meta: { title: "Internal Routing Item View" },
            component: () => import("@/views/internalRoutingItem/InternalRoutingItemView.vue"),
          },
          {
            path: "edit",
            name: names.edit,
            meta: { title: "Internal Routing Item Edit", isForm: true },
            component: () => import("@/views/internalRoutingItem/InternalRoutingItemEdit.vue"),
          },
          {
            path: "workFlowTasks",
            name: names.workFlowTasks,
            meta: {
              title: "Internal Routing Item Workflow Task",
              lookupGroups: ["TaskStatus", "TaskPriority", "Employee"],
            },
            component: () => import("@/views/internalRoutingItem/WorkFlowTasksChildList.vue"),
          },
          {
            path: "workFlowTasks/:workFlowTaskId(\\d+)",
            name: names.workFlowTaskEdit,
            meta: { title: "Edit Internal Routing Item Workflow Task", isForm: true },
            component: () => import("@/views/internalRoutingItem/InternalRoutingItemWorkFlowTask.vue"),
          },
          {
            path: "workFlowTasks/new",
            name: names.workFlowTaskNew,
            meta: { title: "Create Internal Routing Item Workflow Task", isForm: true },
            component: () => import("@/views/internalRoutingItem/InternalRoutingItemWorkFlowTask.vue"),
          },
          {
            path: "notes",
            name: names.notes,
            meta: { title: "Internal Routing Item Notes" },
            component: {
              render: () => <EntityNotes idField="mailItemId" routeNamePrefix="InternalRoutingItem.ItemNote" />,
            },
          },
          {
            path: "notes/:annotationId(\\d+)",
            name: names.noteEdit,
            meta: { title: "Edit Internal Routing Item Note", isForm: true },
            component: () => import("@/views/internalRoutingItem/InternalRoutingItemNote.vue"),
          },
          {
            path: "notes/new",
            name: names.noteNew,
            meta: { title: "Create Internal Routing Item Note", isForm: true },
            component: () => import("@/views/internalRoutingItem/InternalRoutingItemNote.vue"),
          },
          // {
          //   path: "documents",
          //   name: names.documents,
          //   meta: { title: "Internal Routing Item Documents" },
          //   component: {
          //     render: () => <EntityDocuments idField="mailItemId" routeNamePrefix="InternalRoutingItem.ItemDocuments" />,
          //   },
          // },
          // {
          //   path: "documents/:documentId(\\d+)",
          //   name: names.documentsEdit,
          //   meta: { title: "Edit Internal Routing Item Document", isForm: true },
          //   component: () => import("@/views/internalRoutingItem/InternalRoutingDocument.vue"),
          // },
          // {
          //   path: "documents/new",
          //   name: names.documentsNew,
          //   meta: { title: "Create Internal Routing Item Documents", isForm: true },
          //   component: () => import("@/views/internalRoutingItem/InternalRoutingDocuments.vue"),
          // },
          {
            path: "activity",
            name: names.audit,
            meta: { title: "Internal Routing Item Audit Activity" },
            component: {
              render: () => <EntityAudit entityType="Item" />,
            },
          },
        ],
      },
    ],
  },
];
export default internalRoutingItemRoutes;
